import { render, staticRenderFns } from "./ReviewStep.vue?vue&type=template&id=17ad6f2d"
import script from "./ReviewStep.vue?vue&type=script&lang=ts"
export * from "./ReviewStep.vue?vue&type=script&lang=ts"
import style0 from "./ReviewStep.vue?vue&type=style&index=0&id=17ad6f2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports